
export default {
  'zh-CN': {
    viewMore: '查看更多',
    close: '关闭',
    purchaseDesc: '采购需求描述',
    noData: '暂无更多信息'
  },
  'en': {
    viewMore: 'More',
    close: 'Close',
    purchaseDesc: 'Purchase demand description',
    noData: 'No more information'
  },
  'ja': {
    viewMore: '查看更多',
    close: '关闭',
    purchaseDesc: '采购需求描述',
    noData: '暂无更多信息'
  }
}
